import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import type { ParsedUrlQuery } from 'querystring';
import { HotelPage } from '@honeycomb/ui';
import { hotelPageQuery, getPageAndGlobalProps, HotelPageQuery } from '@honeycomb/data';

export default function Hotel({ getEstabById }: HotelPageQuery) {
    return <HotelPage {...{ getEstabById }} />;
}

export interface HotelPageParams extends ParsedUrlQuery {
    estabId: string;
}

export type HotelPageContext = GetServerSidePropsContext<HotelPageParams>;

export const getServerSideProps: GetServerSideProps<HotelPageQuery, HotelPageParams> = async (
    context: HotelPageContext
) => {
    const { estabId } = context.params as HotelPageParams;
    return getPageAndGlobalProps<HotelPageQuery, HotelPageContext>(context, hotelPageQuery(estabId));
};
